export const validationIcons = {
  validationCorrectComponent: null,
  validationHintComponent: null,
  validationErrorComponent: null,
};
